import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { 
  Container, 
  Typography, 
  CircularProgress, 
  Alert,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface FaqItem {
  id: number;
  question: string;
  answer: string;
  applicationName: string;
  objectCreated: string;
}

interface ApiResponse {
  result: FaqItem[];
  total: number;
}

const Faq: React.FC = () => {
  const [faqs, setFaqs] = useState<FaqItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await axios.get<ApiResponse>('https://admin.dev.api-bettertrucks.com/api/faqs', {
          params: {
            pageNumber: 0,
            perPage: 50,
            sortProperty: '',
            sortType: 'asc',
            searchProperty: 'applicationName',
            searchValue: 'AddressesCorrectionPortal'
          }
        });
        setFaqs(response.data.result);
        setLoading(false);
      } catch (err) {
        setError('Failed to load FAQs');
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  return (
    <Box sx={{ width: '90%', mx: 'auto', mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" align="center" gutterBottom>
        Frequently Asked Questions
      </Typography>
      <Box sx={{ mt: 4 }}>
        {faqs.map((faq) => (
          <Accordion key={faq.id} sx={{ mb: 2 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`faq-content-${faq.id}`}
              id={`faq-header-${faq.id}`}
            >
              <Typography variant="h6" component="h3">
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" color="text.secondary">
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default Faq; 